import React from "react";
import { CustomBreadcrumb } from "../../components";
import { PRICING_CONSTANTS } from "../../config/constants";
import { PricingStyled } from "./styled";
import PricingList from "./PricingList";

const Pricing = () => {
  return (
    <CustomBreadcrumb
      header={PRICING_CONSTANTS.HEADER}
      currentPage={PRICING_CONSTANTS.BREADCRUMB}
      isFromLandingPage={false}
    >
      <PricingStyled>
        <PricingList />
      </PricingStyled>
    </CustomBreadcrumb>
  );
};

export default Pricing;
